import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Button } from 't3-widgets'

import { Modal } from '../../../../common/components/modal'
import { MIXPANEL_EVENT, checkConsentAndInitializeAnalyticsIfAllowed, trackEvent } from '../../../../common/config'
import { getCookiesConsent, setCookiesConsent } from '../common/cookies-utils'
import { CookiesSettings } from './cookies-settings'

const SCREEN = Object.freeze({
    MAIN: 'MAIN',
    MANAGE: 'MANAGE'
})

const CookiesModal = ({ open, setOpen, intl, fetchTranslateSuccess }) => {
    const [currentScreen, setCurrentScreen] = useState(SCREEN.MAIN)
    const [cookiesSettings, setCookiesSettings] = useState(getCookiesConsent())

    const locale = intl.langCode()

    const navigateToMainScreen = () => setCurrentScreen(SCREEN.MAIN)
    const navigateToManageScreen = () => setCurrentScreen(SCREEN.MANAGE)
    const close = () => setOpen(false)

    const handleSave = () => {
        setCookiesConsent(cookiesSettings)
        checkConsentAndInitializeAnalyticsIfAllowed()
        close()
    }

    const handleDeclineAll = () => {
        setCookiesConsent({
            analytics: false,
            targetedAd: false
        })
        checkConsentAndInitializeAnalyticsIfAllowed()
        close()
    }

    const handleAcceptAll = () => {
        setCookiesConsent({
            analytics: true,
            targetedAd: true
        })
        checkConsentAndInitializeAnalyticsIfAllowed()
        trackEvent(MIXPANEL_EVENT.COOKIES_CONSENT_ACCEPTED)
        close()
    }

    const screenParams = {
        [SCREEN.MAIN]: {
            showLogo: true,
            header: intl.translate('ap_consent_header'),
            content: (
                <>
                    {intl.translateWithLink(
                        'ap_consent_description',
                        `https://www.webfleet.com/${locale}/webfleet/legal/privacy/`
                    )}
                </>
            ),
            buttons: (
                <>
                    <Button onClick={handleAcceptAll} primary>
                        {intl.translate('atl_privacy_btn_accept_all')}
                    </Button>
                    <Button onClick={handleDeclineAll} primary>
                        {intl.translate('btn_decline_all')}
                    </Button>
                    <Button onClick={navigateToManageScreen} primary>
                        {intl.translate('btn_manage')} +
                    </Button>
                </>
            )
        },
        [SCREEN.MANAGE]: {
            showLogo: false,
            header: intl.translate('ap_consent_preferences_header'),
            content: <CookiesSettings onChange={setCookiesSettings} intl={intl} />,
            buttons: (
                <>
                    <Button onClick={navigateToMainScreen}>{intl.translate('ap_generic_button_close')}</Button>
                    <Button onClick={handleSave} primary>
                        {intl.translate('btn_save')}
                    </Button>
                </>
            )
        }
    }[currentScreen]

    return (
        <Modal
            isLoading={!fetchTranslateSuccess}
            isOpen={open}
            buttons={screenParams.buttons}
            showLogo={screenParams.showLogo}
            header={screenParams.header}
        >
            {screenParams.content}
        </Modal>
    )
}

CookiesModal.propTypes = {
    intl: PropTypes.objectOf(PropTypes.func),
    fetchTranslateSuccess: PropTypes.bool,
    open: PropTypes.bool,
    setOpen: PropTypes.func
}

export { CookiesModal }
